// Auto-generated by scripts/generate-registry.mjs from packages/modules/icon_bead/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const icon_bead: ModuleSchema = {
  "id": "icon_bead",
  "uniqueId": "B3D_K7M2Q",
  "createdAt": "2026-10-14T05:57:06Z",
  "updatedAt": "2026-10-14T05:57:06Z",
  "label": "Two-Color Icon Bead",
  "description": "Choose a two-color icon charm with raised details and a horizontal cord tunnel.",
  "category": "accessories",
  "tags": [
    "icon",
    "donut",
    "charm",
    "bead",
    "cord"
  ],
  "sliders": [
    {
      "key": "outerDiameter",
      "label": "Icon Size",
      "min": 32,
      "max": 52,
      "default": 36,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "centerHoleDiameter",
      "label": "Surface Pattern Size",
      "min": 8,
      "max": 14,
      "default": 12,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "overallDepth",
      "label": "Total Bead Depth",
      "min": 10,
      "max": 24,
      "default": 10,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "raisedDepth",
      "label": "Raised Frosting Depth",
      "min": 0.4,
      "max": 2,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "cordHoleDiameter",
      "label": "Horizontal Cord Hole",
      "min": 3,
      "max": 6,
      "default": 5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "cordHoleYOffset",
      "label": "Cord Hole Fine Position",
      "min": -2,
      "max": 2,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    }
  ],
  "selects": [
    {
      "key": "iconPreset",
      "label": "Choose Icon",
      "default": "donut",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ],
      "options": [
        {
          "value": "donut",
          "label": "Donut",
          "group": "Food",
          "sliders": [
            "outerDiameter",
            "centerHoleDiameter",
            "overallDepth",
            "raisedDepth",
            "cordHoleDiameter",
            "cordHoleYOffset"
          ]
        }
      ]
    }
  ],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "icon_body",
      "label": "Donut Body",
      "default": "#DB2777",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "raised_detail",
      "label": "Raised Icon Detail",
      "default": "#FCE7F3",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "icon_bead",
      "label": "Two-Color Icon Bead",
      "name": "Two-Color Icon Bead",
      "color": "#DB2777",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "icon_body",
          "label": "Donut Body",
          "name": "Donut Body",
          "groupId": 0,
          "colorKey": "icon_body",
          "defaultColor": "#DB2777",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "raised_detail",
          "label": "Raised Icon Detail",
          "name": "Raised Icon Detail",
          "groupId": 1,
          "colorKey": "raised_detail",
          "defaultColor": "#FCE7F3",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Complete Icon Bead"
    },
    {
      "id": "0",
      "label": "Download STL - Icon Base"
    },
    {
      "id": "1",
      "label": "Download STL - Raised Detail"
    }
  ]
};
